module.exports = __webpack_public_path__ + "img/chemistry-icon.30464562.svg";